import ReactDOM from 'react-dom/client';
import App from './app/components/App';

const containers = document.querySelectorAll('div.booking-container');

containers.forEach((el) => {
	const root = ReactDOM.createRoot(el);
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				root.render(<App dataUrl={el.getAttribute('data-rest-url') || ''} />);
				observer.unobserve(el); // Stop observing this specific element
			}
		});
	});

	observer.observe(el); // Start observing the element
});
